import {
  ColorsPrimary500,
  ColorsNeutral200,
  ColorsNeutral500,
  Dimensions2,
  Dimensions4,
  Dimensions6,
  Dimensions11,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const wrapper = css({
  gap: Dimensions4,
});

const memberInfo = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: Dimensions2,
  marginTop: Dimensions2,
  gap: Dimensions2,
  width: '100%',
  border: `1px solid ${ColorsNeutral200}`,
  borderRadius: '8px',
  padding: `${Dimensions4} ${Dimensions6}`,

  '@media (max-width: 600px)': {
    flexDirection: 'column',
  },
});

const roleText = css({
  '&.MuiTypography-root': {
    color: ColorsNeutral500,
  },
});

const authorizationTermsModal = css({
  padding: Dimensions11,
  whiteSpace: 'pre-line',

  '& .MuiTypography-body1': {
    color: ColorsNeutral500,
  },
});

const authorizationTermsLink = css({
  textDecoration: 'underline',
  cursor: 'pointer',
  color: ColorsPrimary500,
});

const authorizationTermsText = css({
  color: ColorsNeutral500,
  '& .MuiSvgIcon-fontSizeMedium': {
    color: ColorsNeutral500,
  },
});

const AssignRoleStepStyles = {
  wrapper,
  memberInfo,
  roleText,
  authorizationTermsModal,
  authorizationTermsLink,
  authorizationTermsText,
};

export default AssignRoleStepStyles;
